<template>
  <div>
    <top-bar heading="Video Library"></top-bar>
    <loading-spinner :loading="!loaded"></loading-spinner>
    <div class="container-fluid mt-3 video-library" v-if="loaded">
      <b-card no-body :header="key" v-for="(category, key) in videos" :key="'category-' + key" class="bg-transparent">
        <b-card-body class="row bg-transparent p-0">
          <div class="col-12 col-md-6 col-lg-3 p-3 mb-3" v-for="video in category" :key="video.id">
            <b-card class="h-100 p-0 rounded-top pointer border mb-0" no-body>
              <b-card-body @click="showVideo(video)">
                <div>
                  <b-img :src="video.thumbnail_url" fluid></b-img>
                </div>
                <p class="card-text p-3 h-100">
                  {{ video.title }}
                </p>
              </b-card-body>
              <b-card-footer class="row m-0 p-0">
                <div class="col m-0 p-0">
                  <router-link :to="'/videos/' + video.id + '/edit'" class="btn btn-info btn-block rounded-0">
                    <font-awesome-icon icon="edit"></font-awesome-icon>
                  </router-link>
                </div>
                <div class="col m-0 p-0">
                  <a href class="btn btn-danger btn-block rounded-0" @click.prevent="deleteVideo(video.id)">
                    <font-awesome-icon icon="trash"></font-awesome-icon>
                  </a>
                </div>
              </b-card-footer>

            </b-card>
          </div>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoLibrary',
  data () {
    return {
      videos: {},
      loaded: false
    };
  },
  methods: {
    getVideos () {
      this.loaded = false;
      this.videos = {};
      this.axios.get('/video_library').then(rsp => {
        rsp.data.data.forEach(video => {
          if (!this.videos[video.category]) this.videos[video.category] = [];
          this.videos[video.category].push(video);
        });
        this.loaded = true;
      });
    },
    showVideo (video) {
      this.$modal.show({
        template: `
          <div>
            <b-embed type="iframe"
                     aspect="16by9"
                     frameborder="0"
                     :src="'https://player.vimeo.com/video/' + id"
                     allowfullscreen></b-embed>
          </div>
        `,
        props: ['id']
      }, {
        id: video.vimeo_id
      }, {
        height: 'auto',
        width: '75%',
        adaptive: true
      }, {});
    },
    deleteVideo (id) {
      this.$swal({
        title: 'Are you sure you want to delete this video?',
        text: 'This will delete the video file, and remove all video components!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.delete('/video_library/' + id).then(() => {
            this.getVideos();
            this.$snotify.success('Video Deleted');
          }).catch(err => this.$errorOut(err));
        }
      });
    }
  },
  mounted () {
    this.getVideos();
  },
  metaInfo: {
    title: 'Video Library'
  }
};
</script>

<style lang="scss">
  .video-library {
    .card-img-top {
      width: 100%;
      height: 10vw;
      object-fit: cover;
    }
  }
</style>
